import React, { useMemo } from "react";

import { useRecoilState } from "recoil";
import { rowSelected } from "recoilState/GlobalState";

import { generateColumns } from "services/Local-services";

import { DataGridPro as DataGrid, LicenseInfo } from "@mui/x-data-grid-pro";
// import { DataGrid } from "@mui/x-data-grid";

import classes from "./XGrid.module.scss";
import { LICENSE_KEY } from "consts/env";

LicenseInfo.setLicenseKey(LICENSE_KEY);

export default function XGrid({
    rows,
    titles,
    secondarySelected,
    setSecondarySelected,
    loading,
    checkboxSelection = false,
    hideFooter = false,
    autoHeight = false,
    height,
    isVoucher = false,
    autoRow
}) {
    const [selected, setSelected] = useRecoilState(rowSelected);

    const { row } = secondarySelected ? secondarySelected : selected;
    const setter = setSecondarySelected ? setSecondarySelected : setSelected;

    const columns = useMemo(() => generateColumns(titles), [titles]);

    return (
        <DataGrid
            columns={columns}
            rows={rows || []}
            loading={loading}
            getRowHeight={() => autoRow ??  null }
            // density="compact"
            style={height ? { height } : undefined}
            checkboxSelection={checkboxSelection}
            onRowClick={(data) => {
                if (data.row.id === row?.id) {
                    setter({ status: false, row: {} })
                    return;
                }
                setter({ status: true, row: data.row })
            }}
            selectionModel={row?.id || []}
            className={classes.root}
            rowHeight={36}

            autoPageSize={!autoHeight}
            autoHeight={autoHeight}
            pagination={!hideFooter}
            hideFooter={hideFooter}
            hideFooterSelectedRowCount
            disableMultipleSelection
            disableColumnMenu
            sx={isVoucher ? {
                // Apuntamos directo al contenedor del footer
                '& .MuiDataGrid-footerContainer': {
                    minHeight: '36px !important', // Le bajamos la altura base
                    height: '36px',
                },
                // Opcional: Achicamos un toque el texto y los iconos para que no queden gigantes
                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                    fontSize: '0.75rem',
                    margin: 0,
                },
                '& .MuiTablePagination-actions .MuiIconButton-root': {
                    padding: '4px', // Achica los botones de las flechitas (< >)
                },
            } : {
                '& .MuiDataGrid-row': {
                    minHeight: '36px !important', // El mínimo que vos quieras
                }
            }}
            localeText={{
                noRowsLabel: 'Sin datos',
                noResultsOverlayLabel: 'No se encontraron resultados.',
                errorOverlayDefaultLabel: 'Ha ocurrido un error.',
                MuiTablePagination: {
                    labelRowsPerPage: 'Filas por página:',
                    labelDisplayedRows: ({ from, to, count }) => {
                        const total = count === -1 ? `más de ${to}` : count;
                        return `${from}-${to} de ${total}`;
                    },
                },
            }}
        />
    );
}
